import { render, staticRenderFns } from "./GridResizeBar.vue?vue&type=template&id=2c76859a&scoped=true&lang=pug"
import script from "./GridResizeBar.vue?vue&type=script&lang=ts"
export * from "./GridResizeBar.vue?vue&type=script&lang=ts"
import style0 from "./GridResizeBar.vue?vue&type=style&index=0&id=2c76859a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76859a",
  null
  
)

export default component.exports